import { c as _c } from "react/compiler-runtime";
import { IcoClock16 } from '@onefootprint/icons';
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SettingsSection from '../../shared/settings-section';
import type { CompleteFormData } from '../complete-node.types';
import type { PanelState } from './complete-node-form/use-panel-state';
const DEFAULT_SECS = 10;
type AutoAdvanceFieldsProps = {
  canEdit: boolean;
  /** The hosted page can only follow a link that opens in the same tab; without one it stays. */
  hasSameTabLink: boolean;
  panel: PanelState;
};
export const AutoAdvanceFields = t0 => {
  const $ = _c(29);
  const {
    canEdit,
    hasSameTabLink,
    panel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "completeNode.autoAdvance"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const form = useFormContext();
  let t2;
  if ($[1] !== form.control) {
    t2 = {
      control: form.control,
      name: "autoAdvance"
    };
    $[1] = form.control;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const enabled = useWatch(t2);
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = panel.openSections.autoAdvance;
  let t5;
  if ($[5] !== panel) {
    t5 = open => panel.setSectionOpen("autoAdvance", open);
    $[5] = panel;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp2);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t(_temp3);
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = !canEdit;
  let t9;
  if ($[11] !== form) {
    t9 = checked => {
      const secs = checked ? form.getValues("autoAdvanceSecs") ?? DEFAULT_SECS : null;
      form.setValue("autoAdvanceSecs", secs, {
        shouldDirty: true
      });
    };
    $[11] = form;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <Form.Toggle name="autoAdvance" label={t6} hint={t7} size="compact" disabled={t8} onChange={t9} />;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== canEdit || $[19] !== enabled || $[20] !== hasSameTabLink || $[21] !== t) {
    t11 = enabled && <div className="flex flex-col gap-2"><Form.Number name="autoAdvanceSecs" label={t(_temp4)} size="compact" disabled={!canEdit} decimalPlaces={0} allowNegative={false} thousandsSeparator={false} rules={{
        required: t(_temp5),
        min: {
          value: 3,
          message: t(_temp6)
        },
        max: {
          value: 120,
          message: t(_temp7)
        }
      }} />{!hasSameTabLink && <p className="text-caption-2 text-tertiary">{t(_temp8)}</p>}</div>;
    $[18] = canEdit;
    $[19] = enabled;
    $[20] = hasSameTabLink;
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== panel.openSections.autoAdvance || $[24] !== t10 || $[25] !== t11 || $[26] !== t3 || $[27] !== t5) {
    t12 = <SettingsSection title={t3} icon={IcoClock16} keepMounted={true} open={t4} onOpenChange={t5}>{t10}{t11}</SettingsSection>;
    $[23] = panel.openSections.autoAdvance;
    $[24] = t10;
    $[25] = t11;
    $[26] = t3;
    $[27] = t5;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_1) {
  return $_1.hint;
}
function _temp4($_2) {
  return $_2.secondsLabel;
}
function _temp5($_3) {
  return $_3.rangeError;
}
function _temp6($_4) {
  return $_4.rangeError;
}
function _temp7($_5) {
  return $_5.rangeError;
}
function _temp8($_6) {
  return $_6.noSameTabLink;
}